import { Components } from "@thisgorilla/primate-ds";
import { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { CommentsProps } from "../../../../../redux/slices/comments/comments";
import { API_CALLS } from "../../../../../API/api_calls";

const GIF = ({
  commentGIF,
  setCommentGIF,
  post_id,
  setIsImageUploading,
  isGIFUploaded,
  isEditMode,
}: {
  commentGIF: CommentsProps.GIF;
  setCommentGIF: Dispatch<SetStateAction<CommentsProps.GIF | null>>;
  setIsImageUploading: Dispatch<SetStateAction<boolean>>;
  post_id: string;
  isGIFUploaded: boolean;
  isEditMode: boolean;
}) => {
  return (
    <Container>
      <Image src={commentGIF.url} />
      <CloseButton>
        <Components.IconButton
          iconType="X"
          disabled={false}
          kind="Floating"
          onClick={() => {
            if (isEditMode && !isGIFUploaded) {
              return setCommentGIF(null);
            }
            API_CALLS.COMMENTS.deleteATemporaryCommentGif(
              {
                post_id,
                id: commentGIF.id,
              },
              setCommentGIF,
              setIsImageUploading
            );
          }}
          size="XXS"
        />
      </CloseButton>
    </Container>
  );
};

export default GIF;

const Container = styled.div`
  position: relative;
  width: fit-content;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-l"]};
`;
const Image = styled.img`
  width: 140px;
  height: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  display: block;
`;

const CloseButton = styled.div`
  position: absolute;
  top: -${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: -${({ theme }) => theme.spacing["spacing-2"].value}rem;
  cursor: pointer;
`;
